import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Round 90 decies: pagina "/commesse" ora è un semplice redirect alla vera
// "Gestione Cantieri" (/gestore-cantieri) per eliminare la doppia UI che confondeva l'utente.
export default function Commesse() {
  const nav = useNavigate();
  useEffect(() => { nav("/gestore-cantieri", { replace: true }); }, [nav]);
  return null;
}
